var map = {
	"./trophy1.png": "30e7",
	"./trophy2.png": "64ae",
	"./trophy3.png": "b027",
	"./trophy4.png": "7b6d",
	"./trophy5.png": "56d8",
	"./trophy6.png": "f31c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "95ef";